/**
 * Module dependencies.
 */

import { Theme } from '@emotion/react';
import { theme } from 'styled-tools';
import colorUtil from 'color';

/**
 * Export `transparentize`.
 */

export function transparentize(value: string, transparency: number): string {
  return colorUtil(value).alpha(transparency).rgb().string();
}

/**
 * Resolve color value.
 */

function resolveColorValue<Props, Theme>(
  colorName: string,
): (props: Props & { theme: Theme }) => Theme[keyof Theme] | undefined {
  return theme(`custom.colors.${colorName}`);
}

/**
 * Export `color`.
 */

export function color<Props = unknown>(
  colorName: string,
  transparency?: number,
): (props: Props & { theme: Theme }) => string | undefined {
  return (props: Props & { theme: Theme }) => {
    const colorValue = resolveColorValue<Props, Theme>(colorName)(props);

    if (colorValue && transparency) {
      return transparentize(colorValue, transparency);
    }

    return colorValue;
  };
}
